(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["page-faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // Acordeón: solo un item abierto a la vez, por acordeón
    const accordions = document.querySelectorAll('.accordion');

    accordions.forEach((accordion) => {
      const detailsItems = accordion.querySelectorAll('accordion-custom details');

      detailsItems.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            detailsItems.forEach((otherItem) => {
              if (otherItem !== item) {
                otherItem.open = false;
              }
            });
          }
        });
      });

      // Ver más / Ver menos
      const toggleButton = accordion.querySelector('.accordion__toggle-more');
      if (!toggleButton) {
        return;
      }

      const wrapper = accordion.querySelector('.accordion__extra-wrapper');
      const inner = accordion.querySelector('.accordion__extra-inner');
      const textShow = toggleButton.dataset.textShow || toggleButton.textContent;
      const textHide = toggleButton.dataset.textHide || toggleButton.textContent;

      if (!wrapper || !inner) {
        return;
      }

      // Medimos el INTERIOR (sin recorte), nunca el propio wrapper animado:
      // el wrapper tiene max-height fijado por nosotros, así que su tamaño
      // nunca refleja el contenido real. El interior sí, incluso si el
      // usuario abre un <details> extra después de desplegar el bloque.
      const syncHeight = () => {
        console.log('[FAQ] syncHeight llamado. is-expanded:', wrapper.classList.contains('is-expanded'), '| inner.scrollHeight:', inner.scrollHeight, '| wrapper.style.maxHeight actual:', wrapper.style.maxHeight);
        if (wrapper.classList.contains('is-expanded')) {
          wrapper.style.maxHeight = inner.scrollHeight + 'px';
          console.log('[FAQ] max-height actualizado a:', wrapper.style.maxHeight);
        }
      };

      console.log('[FAQ] ResizeObserver disponible:', !!window.ResizeObserver, '| inner encontrado:', inner, '| wrapper encontrado:', wrapper);

      if (window.ResizeObserver) {
        const resizeObserver = new ResizeObserver(syncHeight);
        resizeObserver.observe(inner);
      } else {
        // Fallback para navegadores sin ResizeObserver
        inner.querySelectorAll('details').forEach((detailsEl) => {
          detailsEl.addEventListener('toggle', syncHeight);
        });
      }

      toggleButton.addEventListener('click', () => {
        const expand = toggleButton.getAttribute('aria-expanded') !== 'true';
        console.log('[FAQ] click en Ver más/menos. expand:', expand, '| inner.scrollHeight en este momento:', inner.scrollHeight);

        if (expand) {
          wrapper.classList.add('is-expanded');
          wrapper.style.maxHeight = inner.scrollHeight + 'px';
          console.log('[FAQ] wrapper expandido, max-height puesto a:', wrapper.style.maxHeight);
        } else {
          // Fijamos la altura actual antes de animar a 0, y cerramos
          // cualquier pregunta extra que estuviera abierta.
          wrapper.style.maxHeight = inner.scrollHeight + 'px';
          inner.querySelectorAll('details[open]').forEach((detailsEl) => {
            detailsEl.open = false;
          });

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              wrapper.classList.remove('is-expanded');
              wrapper.style.maxHeight = '0px';
            });
          });
        }

        toggleButton.setAttribute('aria-expanded', String(expand));
        toggleButton.textContent = expand ? textHide : textShow;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
